import { z } from "zod";
import { MEMBERS_MAX, MEMBERS_MIN } from "@/lib/session-members";

export const serviceModalitySchema = z.enum(["online", "in_person", "both"]);

/**
 * Dozvoljeno trajanje usluge u minutama, isto za formu (ServiceForm) i server.
 * Postojeće usluge su između 30 i 90 minuta, pa ovaj raspon nijednu ne obara.
 */
export const SERVICE_DURATION_MIN = 15;
export const SERVICE_DURATION_MAX = 240;
export const SERVICE_DURATION_ERROR = `Trajanje mora biti između ${SERVICE_DURATION_MIN} i ${SERVICE_DURATION_MAX} minuta.`;

export const DISCOUNT_PRICE_ERROR = "Promotivna cijena mora biti niža od redovne cijene";

const MAX_MEMBERS_ERROR = `Broj članova mora biti između ${MEMBERS_MIN} i ${MEMBERS_MAX}.`;
/** Usluga sa više članova; null = obična usluga za jednu osobu (src/lib/session-members.ts). */
const maxMembersSchema = z
  .number(MAX_MEMBERS_ERROR)
  .int(MAX_MEMBERS_ERROR)
  .min(MEMBERS_MIN, MAX_MEMBERS_ERROR)
  .max(MEMBERS_MAX, MAX_MEMBERS_ERROR)
  .nullable()
  .optional();

const durationSchema = z
  .number(SERVICE_DURATION_ERROR)
  .int(SERVICE_DURATION_ERROR)
  .min(SERVICE_DURATION_MIN, SERVICE_DURATION_ERROR)
  .max(SERVICE_DURATION_MAX, SERVICE_DURATION_ERROR);

const nameSchema = z.string().trim().min(1).max(200);
const descriptionSchema = z.string().trim().min(1).max(5000);

export const createServiceSchema = z
  .object({
    name: nameSchema,
    description: descriptionSchema,
    durationMinutes: durationSchema,
    price: z.number().min(0.01).max(100000),
    discountPrice: z.number().min(0.01).max(100000).optional(),
    modality: serviceModalitySchema.optional().default("online"),
    maxMembers: maxMembersSchema,
  })
  .superRefine((data, ctx) => {
    if (data.discountPrice !== undefined && data.discountPrice >= data.price) {
      ctx.addIssue({ code: "custom", path: ["discountPrice"], message: DISCOUNT_PRICE_ERROR });
    }
  });

// Kad PATCH nosi samo jednu od dvije cijene, poređenje sa spremljenom drugom
// radi handler (handleUpdateService), jer shema ne zna šta je u bazi.
export const updateServiceSchema = z
  .object({
    name: nameSchema.optional(),
    description: descriptionSchema.optional(),
    durationMinutes: durationSchema.optional(),
    price: z.number().min(0.01).max(100000).optional(),
    discountPrice: z.number().min(0.01).max(100000).nullable().optional(),
    isActive: z.number().int().min(0).max(1).optional(),
    modality: serviceModalitySchema.optional(),
    maxMembers: maxMembersSchema,
  })
  .superRefine((data, ctx) => {
    if (
      data.discountPrice !== undefined &&
      data.discountPrice !== null &&
      data.price !== undefined &&
      data.discountPrice >= data.price
    ) {
      ctx.addIssue({ code: "custom", path: ["discountPrice"], message: DISCOUNT_PRICE_ERROR });
    }
  });
